export const createInvoiceData = ( order_no, calories, fat, carbs,mama, protein, productDetails) =>{
    return {
      order_no,
      calories,
      fat,
      carbs,
      mama,
      protein,
      productDetails
    };
  }

  export const createPaymentData = (order_no, date, total_items, earnings) => {
    return {
      order_no,
      date,
      total_items,
      earnings,
    };
  };

  export const orderManagementData = (order_no, order_placed_at, ship_By, total_items, pending_amount, 
    // btn_action, 
    // action_status,
    status,
     productDetails
    ) => {
    return {
      order_no, order_placed_at, ship_By, total_items, pending_amount, 
      // btn_action, 
      // action_status,
      status,
       productDetails
    };
  }

  export const orderManagementDataForActive = (order_no, order_placed_at, total_items, pending_amount, 
    // action_status,
    status,
     productDetails
    ) => {
    return {
      order_no, order_placed_at, total_items, pending_amount, 
      // action_status,
      status,
       productDetails
    };
  }
  export const orderManagementDataForReturned = (order_no, order_placed_at, total_items, returned_items, 
    status,
     productDetails,
     total_amount
    ) => {
    return {
      order_no, order_placed_at, total_items, returned_items, 
      status,
       productDetails,
       total_amount
    };
  }
  export const orderManagementDataForCancelled = (order_no, order_placed_at, order_cancelled_at, total_items,
    // action_status,
    status,
     productDetails,
     total_amount
    ) => {
    return {
      order_no, order_placed_at, order_cancelled_at, total_items 
      ,
      status,
       productDetails,
       total_amount
    };
  }


  export const createProductsData = (product_name, product_id, total_qnt, sold_qnt, available_qnt, item_status, edit_CTA, mobile_productDetails) => {
    return {
      product_name,
      product_id,
      total_qnt,
      sold_qnt,
      available_qnt,
      item_status,
      edit_CTA,
      mobile_productDetails
    };
  };

